export default __webpack_public_path__ + "static/media/spacecowboy1.6a0415f5.png";